<template>
  <div class="w-100">
    <div v-if="is_load" class="w-100 py-5 text-center">
      <loader />
    </div>
    <template v-else>
      <div v-if="error != ''" class="w-100 py-5">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <PaymentResultActivity :parent_data="data" v-if="data.pos.pos_type == 'SPA' || data.pos.pos_type == 'ACTIVITY'" />
        <b-row class="justify-content-center" no-gutters v-else>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4" class="fit-to-screen bg-white">
            <PaymentResultGeneral />
          </b-col>
        </b-row>
      </template>
    </template>
  </div>
</template>

<script>
  import { get } from '@/services/index.js'
  import { mapGetters } from 'vuex'
  import PaymentResultActivity from './activity/PaymentResult'
  import PaymentResultGeneral from './TrxResult'

  export default {
    components:{
      PaymentResultActivity,
      PaymentResultGeneral
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {}
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
    },
    mounted(){
      this.loadDetailTrx()
    },
    methods:{
      loadDetailTrx(){
        this.is_load = true
        this.error = ''
        this.data = {}
        const routeQuery = this.$route.query;
        let params = {
          merchant_id: this.getMerchant.id
        }
        if(this.$isNotEmptyV2(routeQuery) && this.$isNotEmptyV2(routeQuery.tx_sk)){
          params.tx_sk = routeQuery.tx_sk
        }
        get("CORE_HOTEL",`merchant-pos/transaction/${this.$route.params.trx_id}`,params).then(response=>{
          let res = response.data
          if(res.success){
            this.data = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
			},
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/ConciergeTrxResult.vue